module.exports = __webpack_public_path__ + "static/media/support-success-update-v3.58651621.png";